import {
  getAccessibleOrgIds,
  hasSuperAdminPlatformAccess,
  isAdminPlatformAllowlistedUsername,
  isLegacyPermissionsDict,
  permissionsFromPayload,
} from "./jwt";
import { isVerifierFromJwt } from "./platform-personas";
import type { AuthTokenPayload } from "./types";

export const VERIFICATION_BATCHES_PATH = "/verification/batches";

function hasTenantPermissions(payload: AuthTokenPayload): boolean {
  const raw = payload.permissions;
  if (Array.isArray(raw) && raw.length > 0) {
    return true;
  }
  if (isLegacyPermissionsDict(raw)) {
    return Object.keys(raw).filter((k) => k !== "*").length > 0;
  }
  return false;
}

/** Whether the user may use the admin app at all (login + token refresh). */
export function canAccessAdminApp(payload: AuthTokenPayload | null | undefined): boolean {
  if (!payload) {
    return false;
  }
  // Platform personas are classified as non-pilot by the API before issuance.
  if (payload.is_pilot === true) {
    return false;
  }
  if (isAdminPlatformAllowlistedUsername(payload.username)) {
    return true;
  }
  if (isVerifierFromJwt(payload)) {
    return true;
  }
  if ((payload.platform_permissions?.length ?? 0) > 0) {
    return true;
  }
  if (hasTenantPermissions(payload)) {
    return true;
  }
  return permissionsFromPayload(payload).length > 0;
}

/** Verifier persona with no tenant org membership and not platform super-admin. */
export function isVerifierOnlyUser(payload: AuthTokenPayload | null | undefined): boolean {
  if (!payload || !isVerifierFromJwt(payload)) {
    return false;
  }
  if (hasSuperAdminPlatformAccess(payload)) {
    return false;
  }
  if (isAdminPlatformAllowlistedUsername(payload.username)) {
    return false;
  }
  return getAccessibleOrgIds(payload).length === 0;
}

export function getDefaultPostLoginPath(payload: AuthTokenPayload | null | undefined): string {
  if (isVerifierOnlyUser(payload)) {
    return VERIFICATION_BATCHES_PATH;
  }
  return "/";
}
